import salta_ResultType from '../model/salta_ResultType';
import SensorResultTable from './SensorResultTable';

type propsType = {
    sensorlogs: salta_ResultType[]
}

const COLUMNS = ["no", "app_id", "manufacturer_id", "model", "deviceType", "serial_number", "adv_type", "angle", "battery", "status", "sw2", "jp4", "jp3", "jp2", "jp1", "add1", "add2", "macaddress", "rssi", "detected", "arrived"];

const SensorLog_salta_Result = (props: propsType) => (
    <SensorResultTable rows={props.sensorlogs} columnKeys={COLUMNS} />
);

export default SensorLog_salta_Result;
